module.exports = __webpack_public_path__ + "static/media/BizTech4.28041b8c.jpg";